import { render, staticRenderFns } from "./InvitationCard.vue?vue&type=template&id=1f6186ef&scoped=true"
import script from "./InvitationCard.vue?vue&type=script&lang=js"
export * from "./InvitationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6186ef",
  null
  
)

export default component.exports